/**
 * Enhanced UX Improvements for GrapesJS Email Editor
 * Makes the editor more intuitive, accessible, and professional
 */

export default function initEnhancedUXImprovements(editor) {

  // ========================================
  // 1. IMPROVE TOOLBAR WITH LABELS
  // ========================================
  function addToolbarLabels() {
    // Add text labels to toolbar buttons for clarity
    const toolbarButtons = document.querySelectorAll('.gjs-pn-buttons .gjs-pn-btn');

    const buttonLabels = {
      'sw-visibility': 'Borders',
      'fullscreen': 'Fullscreen',
      'export-template': 'Export',
      'undo': 'Undo',
      'redo': 'Redo',
      'gjs-open-import-webpage': 'Import',
      'canvas-clear': 'Clear',
    };

    let labelCount = 0;
    toolbarButtons.forEach(btn => {
      const btnId = btn.id;
      if (buttonLabels[btnId] && !btn.querySelector('.btn-label')) {
        const label = document.createElement('span');
        label.className = 'btn-label';
        label.textContent = buttonLabels[btnId];
        label.style.cssText = `
          font-size: 11px;
          display: block;
          margin-top: 2px;
          opacity: 0.8;
        `;
        btn.appendChild(label);
        labelCount++;
      }
    });

  }

  // ========================================
  // 2. COMPONENT SELECTION FEEDBACK (DISABLED)
  // ========================================
  // DISABLED - The component:selected event interferes with GrapesJS's
  // built-in panel system (Layer Manager, etc.) and causes crashes
  /*
  editor.on('component:selected', (component) => {
    try {
      // Validate component
      if (!component || typeof component.getName !== 'function') {
        return;
      }

      // Show component path breadcrumb
      showComponentBreadcrumb(component);
    } catch (error) {
      // Silently handle
    }
  });
  */

  /*
  editor.on('component:deselected', () => {
    try {
      // Hide breadcrumb when nothing is selected
      const breadcrumb = document.querySelector('.gjs-component-breadcrumb');
      if (breadcrumb) {
        breadcrumb.style.display = 'none';
      }
    } catch (error) {
      // Silently handle errors
    }
  });
  */

  // ========================================
  // 3. COMPONENT BREADCRUMB NAVIGATION (DISABLED)
  // ========================================
  // DISABLED - Breadcrumb feature disabled because it interferes with
  // GrapesJS panel buttons and causes the Layer Manager to crash
  /*
  function showComponentBreadcrumb(component) {
    console.log('[Breadcrumb] showComponentBreadcrumb called');

    // Safety check
    if (!component || typeof component.getName !== 'function') {
      console.log('[Breadcrumb] Invalid component');
      return;
    }

    console.log('[Breadcrumb] Component name:', component.getName());

    let breadcrumbContainer = document.querySelector('.gjs-component-breadcrumb');

    if (!breadcrumbContainer) {
      console.log('[Breadcrumb] Creating new breadcrumb container');
      breadcrumbContainer = document.createElement('div');
      breadcrumbContainer.className = 'gjs-component-breadcrumb';
      breadcrumbContainer.style.cssText = `
        position: fixed;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(0, 0, 0, 0.85);
        color: white;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 12px;
        z-index: 10000;
        display: flex;
        align-items: center;
        gap: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        backdrop-filter: blur(10px);
        pointer-events: auto;
      `;

      // Safely append to body
      try {
        document.body.appendChild(breadcrumbContainer);
        console.log('[Breadcrumb] Container appended to body');
      } catch (error) {
        console.log('[Breadcrumb] Failed to append:', error.message);
        return;
      }
    } else {
      console.log('[Breadcrumb] Using existing container');
    }

    // Make visible
    breadcrumbContainer.style.display = 'flex';
    console.log('[Breadcrumb] Set display to flex');

    // Build breadcrumb path safely
    const path = [];
    let current = component;
    let safetyCounter = 0;
    const maxDepth = 20;

    try {
      while (current && safetyCounter < maxDepth) {
        const name = (typeof current.getName === 'function' ? current.getName() : null) ||
                     (typeof current.get === 'function' ? current.get('tagName') : null) ||
                     'Component';

        path.unshift({
          name: name,
          component: current
        });

        // Get parent
        if (typeof current.parent === 'function') {
          const parent = current.parent();

          // Stop at wrapper or if no parent
          if (!parent || (parent.get && parent.get('type') === 'wrapper')) {
            break;
          }

          current = parent;
        } else {
          break;
        }

        safetyCounter++;
      }
    } catch (error) {
      return;
    }

    // Filter out wrapper from display
    const displayPath = path.filter(item => item.name.toLowerCase() !== 'wrapper');

    if (displayPath.length === 0) {
      breadcrumbContainer.style.display = 'none';
      return;
    }

    // Render breadcrumb
    breadcrumbContainer.innerHTML = displayPath.map((item, idx) => {
      const isLast = idx === displayPath.length - 1;
      const escapedName = item.name.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return `
        <span class="breadcrumb-item ${isLast ? 'active' : ''}" data-index="${idx}">
          ${escapedName}
        </span>
        ${!isLast ? '<span class="separator">›</span>' : ''}
      `;
    }).join('');

    // Add click handlers
    breadcrumbContainer.querySelectorAll('.breadcrumb-item').forEach((item, idx) => {
      item.style.cssText = `
        cursor: pointer;
        opacity: ${item.classList.contains('active') ? '1' : '0.6'};
        transition: opacity 0.2s;
      `;

      item.addEventListener('click', () => {
        try {
          if (displayPath[idx] && displayPath[idx].component) {
            editor.select(displayPath[idx].component);
          }
        } catch (error) {
          // Silently handle
        }
      });

      item.addEventListener('mouseenter', () => {
        item.style.opacity = '1';
      });

      item.addEventListener('mouseleave', () => {
        if (!item.classList.contains('active')) {
          item.style.opacity = '0.6';
        }
      });
    });

    console.log('[Breadcrumb] Breadcrumb fully rendered with', displayPath.length, 'items');
  }
  */

  // ========================================
  // 4. KEYBOARD SHORTCUTS OVERLAY
  // ========================================
  function createShortcutsOverlay() {
    const shortcuts = [
      { keys: 'Ctrl/⌘ + Z', action: 'Undo' },
      { keys: 'Ctrl/⌘ + Shift + Z', action: 'Redo' },
      { keys: 'Ctrl/⌘ + C', action: 'Copy component' },
      { keys: 'Ctrl/⌘ + V', action: 'Paste component' },
      { keys: 'Delete/Backspace', action: 'Delete selected' },
      { keys: 'Ctrl/⌘ + S', action: 'Save (if enabled)' },
      { keys: 'Esc', action: 'Deselect' },
      { keys: '?', action: 'Show this help' },
    ];

    const overlay = document.createElement('div');
    overlay.className = 'gjs-shortcuts-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      z-index: 10000;
      display: none;
      align-items: center;
      justify-content: center;
      backdrop-filter: blur(5px);
    `;

    const content = document.createElement('div');
    content.style.cssText = `
      background: #2c2c2c;
      border-radius: 12px;
      padding: 32px;
      max-width: 500px;
      color: white;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
    `;

    content.innerHTML = `
      <h2 style="margin: 0 0 24px 0; font-size: 24px; font-weight: 600;">Keyboard Shortcuts</h2>
      <div style="display: grid; gap: 12px;">
        ${shortcuts.map(s => `
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <kbd style="
              background: #444;
              padding: 4px 12px;
              border-radius: 4px;
              font-family: monospace;
              font-size: 13px;
              min-width: 140px;
            ">${s.keys}</kbd>
            <span style="margin-left: 16px; opacity: 0.8;">${s.action}</span>
          </div>
        `).join('')}
      </div>
      <button class="close-shortcuts" style="
        margin-top: 24px;
        width: 100%;
        padding: 12px;
        background: #4285f4;
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
        transition: background 0.2s;
      ">Close (Esc)</button>
    `;

    overlay.appendChild(content);
    document.body.appendChild(overlay);

    // Close handlers
    const closeBtn = content.querySelector('.close-shortcuts');
    closeBtn.addEventListener('click', () => {
      overlay.style.display = 'none';
    });

    closeBtn.addEventListener('mouseenter', () => {
      closeBtn.style.background = '#357ae8';
    });

    closeBtn.addEventListener('mouseleave', () => {
      closeBtn.style.background = '#4285f4';
    });

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.style.display = 'none';
      }
    });

    // Show with ? key
    document.addEventListener('keydown', (e) => {
      if (e.key === '?' && !e.ctrlKey && !e.metaKey) {
        const isInputFocused = document.activeElement.tagName === 'INPUT' ||
                               document.activeElement.tagName === 'TEXTAREA' ||
                               document.activeElement.isContentEditable;

        if (!isInputFocused) {
          overlay.style.display = 'flex';
          e.preventDefault();
        }
      }

      if (e.key === 'Escape' && overlay.style.display === 'flex') {
        overlay.style.display = 'none';
      }
    });

    return overlay;
  }

  // ========================================
  // 5. LOADING STATES & SAVE INDICATOR
  // ========================================
  function createSaveIndicator() {
    const indicator = document.createElement('div');
    indicator.className = 'gjs-save-indicator';
    indicator.style.cssText = `
      position: fixed;
      top: 16px;
      right: 16px;
      padding: 8px 16px;
      background: #4caf50;
      color: white;
      border-radius: 20px;
      font-size: 13px;
      font-weight: 500;
      opacity: 0;
      transform: translateY(-10px);
      transition: all 0.3s ease;
      z-index: 9999;
      display: flex;
      align-items: center;
      gap: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    `;

    indicator.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
      <span>All changes saved</span>
    `;

    document.body.appendChild(indicator);

    return {
      show(message = 'All changes saved', type = 'success') {
        const colors = {
          success: '#4caf50',
          saving: '#ff9800',
          error: '#f44336'
        };

        indicator.style.background = colors[type] || colors.success;
        indicator.querySelector('span').textContent = message;
        indicator.style.opacity = '1';
        indicator.style.transform = 'translateY(0)';

        if (type === 'success') {
          setTimeout(() => {
            indicator.style.opacity = '0';
            indicator.style.transform = 'translateY(-10px)';
          }, 3000);
        }
      },

      hide() {
        indicator.style.opacity = '0';
        indicator.style.transform = 'translateY(-10px)';
      }
    };
  }

  // ========================================
  // 6. IMPROVED COMPONENT HOVER STATES
  // ========================================
  // DISABLED - These event handlers conflict with GrapesJS's built-in hover system
  // and cause blue dotted lines to appear everywhere
  /*
  editor.on('component:hover', (component) => {
    try {
      const el = component ? component.getEl() : null;
      if (el && !editor.getSelected()) {
        el.style.outline = '2px dashed #4285f4';
        el.style.outlineOffset = '2px';
      }
    } catch (error) {
      console.debug('Error in component:hover handler:', error.message);
    }
  });

  editor.on('component:hover:out', (component) => {
    try {
      const el = component ? component.getEl() : null;
      if (el) {
        el.style.outline = '';
        el.style.outlineOffset = '';
      }
    } catch (error) {
      console.debug('Error in component:hover:out handler:', error.message);
    }
  });
  */

  // ========================================
  // 7. PANEL RESIZE HANDLES
  // ========================================
  function addPanelResizers() {
    // Disable panel resizers for now - they interfere with GrapesJS layout
    // TODO: Implement properly with correct panel selectors
    return;

    /*
    // Add resize handle between left panel and canvas
    const leftPanel = document.querySelector('.gjs-pn-views-container');
    const canvas = document.querySelector('.gjs-cv-canvas');

    if (leftPanel && canvas) {
      // Check if panel has valid width
      if (leftPanel.offsetWidth === 0) {
        console.debug('Left panel has 0 width, skipping resizer');
        return;
      }

      const resizer = document.createElement('div');
      resizer.className = 'gjs-panel-resizer';
      resizer.style.cssText = `
        width: 4px;
        cursor: ew-resize;
        background: transparent;
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        z-index: 100;
        transition: background 0.2s;
      `;

      resizer.addEventListener('mouseenter', () => {
        resizer.style.background = '#4285f4';
      });

      resizer.addEventListener('mouseleave', () => {
        resizer.style.background = 'transparent';
      });

      let isResizing = false;
      let startX, startWidth;

      resizer.addEventListener('mousedown', (e) => {
        isResizing = true;
        startX = e.pageX;
        startWidth = leftPanel.offsetWidth;
        document.body.style.cursor = 'ew-resize';
        e.preventDefault();
      });

      document.addEventListener('mousemove', (e) => {
        if (!isResizing) return;

        const delta = e.pageX - startX;
        const newWidth = startWidth + delta;

        // Constrain width
        if (newWidth > 200 && newWidth < 600) {
          leftPanel.style.width = `${newWidth}px`;
        }
      });

      document.addEventListener('mouseup', () => {
        if (isResizing) {
          isResizing = false;
          document.body.style.cursor = '';
        }
      });

      try {
        leftPanel.style.position = 'relative';
        leftPanel.appendChild(resizer);
      } catch (error) {
        console.debug('Could not add panel resizer:', error.message);
      }
    }
    */
  }

  // ========================================
  // 8. ENHANCED CSS ANIMATIONS
  // ========================================
  function injectEnhancedStyles() {
    const style = document.createElement('style');
    style.textContent = `
      /* Selection pulse animation - DISABLED, causes visual artifacts */
      /*
      @keyframes gjs-pulse {
        0%, 100% { box-shadow: 0 0 0 0 rgba(66, 133, 244, 0.7); }
        50% { box-shadow: 0 0 0 6px rgba(66, 133, 244, 0); }
      }

      .gjs-selected-pulse {
        animation: gjs-pulse 2s infinite;
      }
      */

      /* Improved button hover states - DISABLED, breaks click handlers */
      /*
      .gjs-pn-btn:hover {
        background: rgba(66, 133, 244, 0.1) !important;
        transform: translateY(-1px);
        transition: all 0.2s ease;
      }

      .gjs-pn-btn:active {
        transform: translateY(0);
      }
      */

      /* Smooth transitions for panels - DISABLED, may interfere with GrapesJS */
      /*
      .gjs-pn-views-container {
        transition: width 0.3s ease;
      }
      */

      /* Improved scrollbars */
      .gjs-sm-sectors::-webkit-scrollbar,
      .gjs-layers::-webkit-scrollbar,
      .gjs-blocks-c::-webkit-scrollbar {
        width: 8px;
      }

      .gjs-sm-sectors::-webkit-scrollbar-track,
      .gjs-layers::-webkit-scrollbar-track,
      .gjs-blocks-c::-webkit-scrollbar-track {
        background: #1a1a1a;
      }

      .gjs-sm-sectors::-webkit-scrollbar-thumb,
      .gjs-layers::-webkit-scrollbar-thumb,
      .gjs-blocks-c::-webkit-scrollbar-thumb {
        background: #444;
        border-radius: 4px;
      }

      .gjs-sm-sectors::-webkit-scrollbar-thumb:hover,
      .gjs-layers::-webkit-scrollbar-thumb:hover,
      .gjs-blocks-c::-webkit-scrollbar-thumb:hover {
        background: #555;
      }

      /* Loading spinner */
      @keyframes gjs-spin {
        to { transform: rotate(360deg); }
      }

      .gjs-loading-spinner {
        border: 3px solid rgba(255, 255, 255, 0.3);
        border-top-color: #4285f4;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: gjs-spin 1s linear infinite;
      }
    `;
    document.head.appendChild(style);
  }

  // ========================================
  // INITIALIZE ALL IMPROVEMENTS
  // ========================================
  function initializeUIElements() {
    // Only inject safe CSS styles (scrollbars only)
    try {
      injectEnhancedStyles();
    } catch (error) {
      console.error('Enhanced UX: Could not inject styles:', error);
    }

    // ALL OTHER FEATURES DISABLED - they interfere with GrapesJS button functionality
    // The following features have been tested and found to break panel buttons:
    // - Toolbar labels (appendChild breaks button event handlers)
    // - Shortcuts overlay (DOM manipulation during init causes issues)
    // - Save indicator (timing issues with GrapesJS initialization)
    // - Help button (stopPropagation interferes)
    // - Panel resizers (wrong selectors)
  }

  // Try to initialize immediately if editor is already loaded
  if (editor.getWrapper()) {
    setTimeout(initializeUIElements, 500);
  }

  // Also listen for load event in case editor is still loading
  editor.on('load', () => {
    setTimeout(initializeUIElements, 500);
  });
}
